export default class DocumentHelper {
	static getFileNameFromDocumentValue(value) {
		return this.parseDocumentValue(value).fileName;
	}

	static parseDocumentValue(value) {
		if (!value) return;

		const [fileName, fileUUID ] = value.split(':');
		return { fileName , fileUUID };
	}
};

export function documentIsLockedBy(document, lockAction) {
	const locks = document.locks || [];
	return locks.map(lock => lock.action).includes(lockAction);
}
